import PropTypes from 'prop-types';

const enhancedTableColsProps = PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    numeric: PropTypes.bool.isRequired,
    disablePadding: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    defaultSorting: PropTypes.bool.isRequired,
    disableSorting: PropTypes.bool,
    link: PropTypes.bool,
}));

export default enhancedTableColsProps;
